<template>
    <div class="row">
        <div class="col-lg-12">
            <b-card class="bg-default-card" :header="uLang('app.overview')" header-tag="h4">
                <div>
                    <div class="pull-left">
                        <div class="p-2">
                            <span>{{ lang('app.rows_per_page_text') }} : </span>
                            <select class="rowsPerPageClass" name="rowsPerPage" id="rowsPerPage" v-model="rowsPerPage">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="45">45</option>
                                <option value="60">60</option>
                                <option value="90">90</option>
                            </select>
                        </div>
                    </div>
                </div>
                <feedback-table :rows-per-page="rowsPerPage"></feedback-table>
            </b-card>
        </div>
    </div>
</template>

<script>
    import { FeedbackTable } from '~/components/tables'

    export default {
        name: 'Invoices',

        components: {
            FeedbackTable,
        },

        data() {
            return {
                rowsPerPage: "15",
            }
        },
    }
</script>

<style lang="css" scoped>
.rowsPerPageClass {
    display: inline-block;
    width: 100px;
    padding: 6px;
}
</style>